import { Navigate, useParams } from 'react-router-dom';
import { LoadingSpinner } from '@elka/ui';
import { useContacts } from '../features/contacts/hooks/useContacts';

/** /companies/:companyId → /customers/:companyId */
export function CompanyRedirect() {
  const { companyId } = useParams<{ companyId: string }>();
  return <Navigate to={companyId ? `/customers/${companyId}` : '/customers'} replace />;
}

/** /contacts/:contactId → the contact's company page, or the customers list. */
export function ContactRedirect() {
  const { contactId } = useParams<{ contactId: string }>();
  const { contacts, isLoading } = useContacts();
  if (isLoading) return <LoadingSpinner />;
  const companyId = contacts.find((c) => c.id === contactId)?.companyId;
  return <Navigate to={companyId ? `/customers/${companyId}` : '/customers'} replace />;
}
